import {
  ButtonPressedTriggerPayload,
  TimeBasedTriggerPayload,
  Trigger,
  TriggerCreate,
  TriggerType,
} from '@ekkogmbh/apisdk';
import { Avatar, Card, CardContent, CardHeader, styled, Typography } from '@mui/material';
import { AvTimer, SettingsRemote } from '@mui/icons-material';
import moment from 'moment';
import { PureComponent } from 'react';
import { spacing } from 'src/Common/Helper/ThemeHelper';

const TriggerTypeTexts: Record<TriggerType, string> = {
  'time-based': 'Time-Based',
  'button-pressed': 'Button-Pressed',
};

const TextTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 700,
}));

interface TriggerCardProps {
  trigger: Trigger | TriggerCreate;
}

export class TriggerCard extends PureComponent<TriggerCardProps> {
  public render(): React.JSX.Element {
    const {
      trigger: { type },
    } = this.props;

    return (
      <Card elevation={4} sx={{ backgroundColor: (theme) => theme.palette.primary.light }}>
        <CardContent sx={{ padding: (theme) => spacing(theme) }}>
          <CardHeader
            disableTypography={true}
            sx={{ padding: (theme) => spacing(theme) }}
            avatar={
              <Avatar sx={{ backgroundColor: (theme) => theme.palette.text.primary }}>
                {this.renderTriggerTypeIcon()}
              </Avatar>
            }
            title={<TextTypography variant={'subtitle1'}>{TriggerTypeTexts[type]}</TextTypography>}
          />
          {this.renderTriggerTypeInfo()}
        </CardContent>
      </Card>
    );
  }

  private renderTriggerTypeIcon = () => {
    const {
      trigger: { type },
    } = this.props;

    switch (type) {
      case TriggerType.BUTTON_PRESSED:
        return <SettingsRemote sx={{ fontSize: 32, color: (theme) => theme.palette.primary.light }} />;
      case TriggerType.TIME_BASED:
      default:
        return <AvTimer sx={{ fontSize: 32, color: (theme) => theme.palette.primary.light }} />;
    }
  };

  private renderTriggerTypeInfo = () => {
    const {
      trigger: { type, payload },
    } = this.props;

    switch (type) {
      case TriggerType.BUTTON_PRESSED:
        const buttonPressedPayload = payload as ButtonPressedTriggerPayload;

        return (
          <TextTypography variant="body2" align={'left'}>
            <ul>
              <li>{'Label-Id: ' + buttonPressedPayload.labelId}</li>
              <li>{'Technology: ' + buttonPressedPayload.technology}</li>
              <li>{'Button-Index: ' + buttonPressedPayload.buttonIndex}</li>
              {buttonPressedPayload.validFrom !== null && (
                <li>{'Valid-From: ' + moment(buttonPressedPayload.validFrom).toDate().toLocaleString()}</li>
              )}
              {buttonPressedPayload.validUntil !== null && (
                <li>{'Valid-Until: ' + moment(buttonPressedPayload.validUntil).toDate().toLocaleString()}</li>
              )}
            </ul>
          </TextTypography>
        );

      case TriggerType.TIME_BASED:
      default:
        const timeBasedPayload = payload as TimeBasedTriggerPayload;
        return (
          <TextTypography variant="h5" align={'center'}>
            {moment(timeBasedPayload.datetime).toDate().toLocaleString()}
          </TextTypography>
        );
    }
  };
}
